@use '@design/design-tokens/border-radius/border-radius' as *;

.entityAvatar {
  width: 16px;
  height: 16px;
  flex: none;
  @include border-radius-full;
  background-color: var(--surface-inverse);
}

.previewTrigger {
  display: inline-flex;

  // Match MentionChip's `.readOnly` middle-alignment — without this the
  // wrapper defaults to `vertical-align: baseline`, sitting higher than
  // unwrapped (watchlist) chips on the same line.
  vertical-align: middle;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--border-primary);
    outline-offset: 2px;
    border-radius: 9999px;
  }
}
